import { NotifyManager } from "notify-component";

import { NotifyManagerErrors } from "#app/constants/NotifyManagerErrors";
import Modal from "#app/interface/modal/Modal";

export interface LoginFormInterface {
    email: string;
    password: string;
    code: string;
    form: string;
}

interface LoginResponseInterface {
    response: any;
    status: number;
    xhr: XMLHttpRequest;
}

export interface SuccessCallbacksListInterface {
    handleCloseModal: () => void;
    setForm: (form: LoginFormInterface) => void;
    setSubmitted: (submitted: boolean) => void;
    callback?: () => void;
}

interface LoginFailureMeta {
    errors?: {
        code?: string[];
    };
}

export const initialLoginFormState: LoginFormInterface = {
    email: "",
    password: "",
    code: "",
    form: "manager",
};
export const initialForbbiddenFormState: { email: string; password: string } = { email: "", password: "" };

export const handleLoginSuccess = (
    loginResponseObject: LoginResponseInterface,
    successCallbacksList: SuccessCallbacksListInterface
) => {
    const { xhr } = loginResponseObject;
    const { handleCloseModal, setForm, setSubmitted, callback } = successCallbacksList;
    const header = xhr.getResponseHeader("Authorization");

    if (header) {
        localStorage.setItem("api_token", header);
        Modal.handleClose();
        handleCloseModal();
        setForm(initialLoginFormState);
        setSubmitted(false);

        callback?.();
    } else {
        NotifyManager.error("", NotifyManagerErrors.AUTH_ERROR);
    }
};

export const handleLoginFailure = (
    type: string,
    responseData: { meta?: LoginFailureMeta } | null | undefined,
    setType: (type: string) => void,
    setSubmitted: (submitted: boolean) => void
) => {
    if (type === "") {
        let enable = false;
        const codeError = responseData?.meta?.errors?.code?.[0];
        if (codeError === "Неверный 2FA код") {
            enable = true;
        }

        setType(enable ? "2fa" : "");
        setSubmitted(false);
    } else {
        setSubmitted(false);
    }
};
